import PropTypes from 'prop-types';

import './MenuItem.css';

import { buildClass } from '../../../libs/classes';

export const menuItemTemplate = {
	danger: 'danger', // Red
	caution: 'caution', // Orange
	safe: 'safe', // Green
	disabled: 'disabled', // Gray
	hidden: 'hidden', // Not displayed
	spacer: 'spacer', // Empty spacer
};

/**
 * Menu item
 */
const MenuItem = ({ text, template, onClick }) => {
	return (
		<div className={buildClass('menu-item').add(template, `template-${template}`)} onClick={handleClick}>
			<div className="text">{text}</div>
			<div className="icon" />
		</div>
	);

	function handleClick(event) {
		if (onClick && template !== menuItemTemplate.disabled) {
			onClick(event);
		}
	}
};

MenuItem.propTypes = {
	// Item text
	text: PropTypes.string.isRequired,
	// Item template (see menuItemTemplate)
	template: PropTypes.string,
	// Callback on item click
	onClick: PropTypes.func.isRequired,
};

/**
 * Menu item acting as link
 */
const MenuLinkItem = ({ text, href, target, template }) => {
	return (
		<div className={buildClass('menu-item').add(template, `template-${template}`)}>
			<a className="text" href={href} target={target}>
				{text}
			</a>
			<div className="icon" />
		</div>
	);
};

MenuLinkItem.propTypes = {
	// Title of link item
	text: PropTypes.string.isRequired,
	// URL for link item
	href: PropTypes.string.isRequired,
	// Target for link item
	target: PropTypes.string,
	// Template for menu item
	template: PropTypes.string,
};

export default MenuItem;
